import { Skeleton } from "@mui/material";
import { FC } from "react";

const TagsSelectSkeleton: FC = () => (
  <Skeleton
    sx={{
      width: "100%",
      height: 58,
      borderRadius: "0.5rem",
      transform: "none",
    }}
  />
);

export default TagsSelectSkeleton;
